import React from 'react';

export default class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = { text: "" };
        this.handleTextChange = this.handleTextChange.bind(this);
        this.changePage = this.changePage.bind(this);

        this.nextPage = this.nextPage.bind(this);
        this.prePage = this.prePage.bind(this);
    }

    nextPage() {
        var pageNumber = this.props.pageNumber;
        var count = this.props.count;
        var perPageCount = this.props.perPageCount;
        var totalPage = (count + perPageCount - 1) / perPageCount;
        pageNumber = pageNumber + 1;
        if (pageNumber <= totalPage)
            if (typeof this.props.onChange === "function") {

                this.props.onChange(pageNumber);
            }

    }
    prePage() {
        var pageNumber = this.props.pageNumber;
        var count = this.props.count;
        var perPageCount = this.props.perPageCount;
        var totalPage = (count + perPageCount - 1) / perPageCount;

        pageNumber = pageNumber - 1;
        if (pageNumber > 0)
            if (typeof this.props.onChange === "function") {

                this.props.onChange(pageNumber);
            }

    }
    handleTextChange(e) {
        this.props.onChange(e.target.value, this.props.name);
    }

    changePage(e) {
        if (e === this.props.pageNumber)
            return;

        if (typeof this.props.onChange === "function") {

            this.props.onChange(e);
        }
    }

    componentDidMount() {
        //   var self = this;
        //   var node = this.refs.myRef;

    }

    render() 
    {

        if(this.props.isReady==false)
        {
            return <div>
                <br/>
            </div>;
        }

        var pageNumber = this.props.pageNumber;
        var count = this.props.count;
        var perPageCount = this.props.perPageCount;





        var totalPage = (count + perPageCount - 1) / perPageCount;

        if (totalPage < 2) {
            return (
                <div className="col-md-12 ">
                </div>
            );
        }

        var minpage = pageNumber - 3;
        if (minpage < 1)
            minpage = 1;

        var maxpage = pageNumber + 3;
        if (maxpage > totalPage)
            maxpage = totalPage;

        var pages = [];

        for (var i = minpage; i <= maxpage; i++) {
            if (i === pageNumber) {
                pages.push({ pageNumber: i, active: true });
            } else
                pages.push({ pageNumber: i, active: false });
        }
        var self = this;
        const pageItems = pages.map((page, index) =>
            // Only do this if items have no stable IDs
            <li className={page.active === true ? "page-item active" : "page-item "} key={index}><a className="page-link" onClick={() => self.changePage(page.pageNumber)}>{page.pageNumber}</a></li>
        );

        return (



            <div className="col-md-12 ">

                <nav aria-label="Page navigation example">
                    <ul className="pagination">
                        <li className="page-item"><a className="page-link" onClick={() => self.prePage()} > قبل  </a></li>
                        {pageItems}
                        <li className="page-item"><a className="page-link" onClick={() => self.nextPage()} > بعد </a></li>
                    </ul>
                </nav>
            </div>
        );

    }
}
/*
function clone(obj) {
    if (null == obj || "object" !== typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;

}
*/



// WEBPACK FOOTER //
// ./src/elements/Pagination.js